import React from "react"

import Layout from "../components/global/Layout"
import HeroContact from "../components/block/HeroContact"
import SEO from "../components/global/SEO"

export default function Contact() {
  return (
    <div>
      <Layout>
        <SEO
          title="Contact Userfy"
          description="Feel free to get in touch for a completely no-obligation discussion about how we might be able to help optimise your user experience."
        />
        <HeroContact title="To discuss how our in-depth user testing could help you:" />
      </Layout>
    </div>
  )
}
